/**
 * @file Presse-papiers de l'éditeur riche, distinguant le collage du chargement.
 * @module common.components.editor.clipboard
 *
 * Quill 1 fait passer par le même `convert` le contenu collé et le HTML chargé
 * dans l'éditeur (valeur enregistrée, via react-quill). Une conversion propre
 * au collage, comme le gras `*texte*` des réseaux sociaux, ne doit pas réécrire
 * un texte enregistré à sa simple ouverture : ce module ne l'applique qu'au
 * collage, quand l'option `socialBold` du presse-papiers est active.
 * Enregistré sur le Quill de react-quill (Quill 1), celui qu'utilise l'éditeur.
 */

import {Quill} from 'react-quill';
import {applySocialBold} from '../../utils/editorPasteMatchers';

const Clipboard = Quill.import('modules/clipboard');

/**
 * Presse-papiers Quill 1 avec conversions réservées au collage.
 */
class PasteAwareClipboard extends Clipboard {
  /**
   * Convertit du HTML en Delta. Appelé avec une chaîne pour charger un
   * contenu, sans argument pour lire ce qui vient d'être collé.
   *
   * @param {string} [html] - HTML à charger ; absent lors d'un collage
   * @return {Object} Delta
   */
  convert(html) {
    if (typeof html === 'string') {
      // Le chargement rappelle convert() sans argument : on le marque pour
      // que cet appel interne ne soit pas pris pour un collage.
      this.isLoadingHtml = true;
      try {
        return super.convert(html);
      } finally {
        this.isLoadingHtml = false;
      }
    }

    const delta = super.convert();
    return !this.isLoadingHtml && this.options.socialBold ? applySocialBold(delta) : delta;
  }
}

Quill.register('modules/clipboard', PasteAwareClipboard, true);
